/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowPatchRequest
 */
export interface WorkflowPatchRequest {
    /**
     * Whether the workflow is enabled or disabled.
     * @type {boolean}
     * @memberof WorkflowPatchRequest
     */
    enabled?: boolean | null;
}

/**
 * Check if a given object implements the WorkflowPatchRequest interface.
 */
export function instanceOfWorkflowPatchRequest(value: object): value is WorkflowPatchRequest {
    return true;
}

export function WorkflowPatchRequestFromJSON(json: any): WorkflowPatchRequest {
    return WorkflowPatchRequestFromJSONTyped(json, false);
}

export function WorkflowPatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowPatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function WorkflowPatchRequestToJSON(json: any): WorkflowPatchRequest {
    return WorkflowPatchRequestToJSONTyped(json, false);
}

export function WorkflowPatchRequestToJSONTyped(value?: WorkflowPatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

